export const getShouldByPassSupplementalQuestions = (): boolean => {
  const bypassSupplementalQuestions = localStorage.getItem('bypassSQ');
  return bypassSupplementalQuestions === 'true' ? true : false;
};
